import { form, errors } from '../state'

/**
 * Form verilerini ve hata durumlarını sıfırlar
 */
export const resetForm = () => {
  // Form alanlarını temizle
  form.suggestion = ''
  form.currentImageUrl = ''
  form.currentVideoUrl = ''
  form.currentText = ''
  form.priority = 3

  // Hata mesajlarını temizle
  Object.keys(errors).forEach(key => errors[key] = '')
}
